import {useInfiniteQuery, type InfiniteData} from '@tanstack/react-query'
import {type AppBskyFeedDefs, AppBskyEmbedVideo} from '@atproto/api'
import {useAgent} from '#/state/session'
import {STALE} from '#/state/queries'

interface VideoTimelinePage {
  posts: AppBskyFeedDefs.PostView[]
  cursor?: string
}

export function useVideoTimelineQuery(options?: {enabled?: boolean}) {
  const agent = useAgent()

  return useInfiniteQuery<VideoTimelinePage, Error, InfiniteData<VideoTimelinePage>, string[], string | undefined>({
    queryKey: ['video-timeline', agent.session?.did ?? 'guest'],
    queryFn: async ({pageParam}) => {
      // Fetch timeline using the Bluesky API
      const res = await agent.getTimeline({
        cursor: pageParam,
        limit: 50, // Fetch more to account for filtering
      })

      if (!res.success) {
        return {posts: [], cursor: undefined}
      }

      // Filter to only posts with video embeds
      const videoPosts = res.data.feed
        .map(item => item.post)
        .filter(post => {
          return post.embed && AppBskyEmbedVideo.isView(post.embed)
        })

      return {
        posts: videoPosts,
        cursor: res.data.cursor,
      }
    },
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.cursor,
    staleTime: STALE.MINUTES.ONE,
    enabled: options?.enabled !== false,
  })
}
